import { Reveal } from "@/components/shared";

const TAGS = ["Diagnóstico preciso", "Decisões com segurança", "Investimentos inteligentes", "Tranquilidade para o síndico"];

export default function StatementBand() {
  return (
    <section className="gold-band relative overflow-hidden">
      <div className="grain absolute inset-0" />
      <div className="relative mx-auto max-w-6xl px-5 py-16 text-center lg:px-8 lg:py-20">
        <Reveal>
          <p className="font-display text-3xl font-extrabold uppercase leading-[1.08] tracking-wide text-navy-950 sm:text-4xl lg:text-5xl">
            Você imagina.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-3 font-display text-3xl font-extrabold uppercase leading-[1.08] tracking-wide text-navy-950 sm:text-4xl lg:text-5xl">
            A gente <span className="underline decoration-navy-950/30 underline-offset-8">realiza.</span>
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            {TAGS.map((t, i) => (
              <span key={t} className="flex items-center gap-5 font-mono text-[10px] font-semibold uppercase tracking-[0.22em] text-navy-900 sm:text-[11px]">
                {t}
                {i < TAGS.length - 1 && <span className="text-navy-950/50">◆</span>}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
